import React, { useState, useEffect } from 'react';
import call_icon from '../../assets/images/call_icon.svg';
import cancel_icon from '../../assets/images/close_icon.svg';
import avatar_icon from '../../assets/images/avatar-icon.svg';
import microphone_icon from '../../assets/images/microphone_icon.svg';
import speaker_icon from '../../assets/images/speaker_icon.svg';
import { makeSupportCall } from "../../Redux/Api/fetch.api";
import { useSignalR } from '../SignalRContext/signalRContext';

const TwilioCallStatus = {
    RINGING: 'ringing', // Make sure this is the correct status
    IN_PROGRESS: 'in-progress',
    COMPLETED: 'completed',
    BUSY: 'busy',
    FAILED: 'failed',
    NO_ANSWER: 'no-answer',
    CANCELED: 'canceled',
    ANSWERED: 'answered'
};

const AudioCall = ({ content, technician, cancelCall }) => {
    const { connection, connected } = useSignalR(); // SignalR connection
    const [requestedBy, setRequestedBy] = useState(content?.requestedBy);
    const [phoneNumber, setPhoneNumber] = useState(content?.phoneNumber);
    const [callStarted, setCallStarted] = useState(false);
    const [callStatus, setCallStatus] = useState("");  // To hold the call status
    const [callDuration, setCallDuration] = useState(0); // To hold the call duration

    // Timer logic
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
 // Timer logic: Tracking total time in seconds
 const [totalSeconds, setTotalSeconds] = useState(0);

 const startTimer = () => {
     const interval = setInterval(() => {
         setTotalSeconds((prevSeconds) => prevSeconds + 1);
     }, 1000);
     return interval;
 };

 const stopTimer = (interval) => {
     clearInterval(interval);
 };

 // Convert total seconds into hours, minutes, and seconds
 const formatDuration = (totalSeconds) => {
     const hours = Math.floor(totalSeconds / 3600);
     const minutes = Math.floor((totalSeconds % 3600) / 60);
     const seconds = totalSeconds % 60;

     if (hours > 0) {
         // If hours is more than 0, show in HH:MM:SS format
         return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
     } else {
         // If hours is 0, show in MM:SS format
         return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
     }
 };

    // Handle call status changes from SignalR
    useEffect(() => {
        let timerInterval = null;

        if (callStatus === TwilioCallStatus.IN_PROGRESS || callStatus === TwilioCallStatus.ANSWERED) {
            timerInterval = startTimer();  // Start the timer when the call is ringing
        } else if ([TwilioCallStatus.COMPLETED, TwilioCallStatus.BUSY, TwilioCallStatus.FAILED, TwilioCallStatus.NO_ANSWER, TwilioCallStatus.CANCELED].includes(callStatus)) {
            if (timerInterval) {
                stopTimer(timerInterval);  // Stop the twimer if the call ends
            }
        }

        return () => {
            if (timerInterval) {
                stopTimer(timerInterval);  // Cleanup the timer on component unmount
            }
        };
    }, [callStatus]);  // Trigger when the call status changes

    // Initialize the SignalR connection
    useEffect(() => {
        connection.on("CallStatusChanged", (callSid, status, from, to, duration) => {
            console.log(`Call SID: ${callSid}, Status: ${status}, From: ${from}, To: ${to}, Duration: ${duration}`);
            setCallStatus(status);  // Update the state with the new call status
            setCallDuration(duration);  // Update the state with the call duration
        });
    }, [connection]);

    const handleCall = () => {
        const payload = {
            ToNumber: phoneNumber,
            ForwardTo: phoneNumber
        };
        const response = makeSupportCall(payload);
        console.log("Call initiated", response);
        setCallStarted(true);  // Set call started to true once the call is initiated
    };

    const handleCancel = () => {
        if (typeof cancelCall === 'function') {
            cancelCall(); // This will call the cancelCall function from the parent
        } else {
            console.error("cancelCall is not a function");
        }
    };


    return (
        <div className="call-box">
            <div className="first-row d-flex align-items-center">
                <div className="avatar">
                    <img width={45} height={45} src={avatar_icon} alt="" />
                </div>
                <div className="avater-info">
                    <div className="d-flex flex-column justify-content-between flex-grow-1 w-100">
                        <h3 className="m-0">{requestedBy}</h3>

                        {callStatus === TwilioCallStatus.RINGING ? (
                            <h6 className='m-0 call-status-font'>Ringing</h6>
                        ) : callStatus === TwilioCallStatus.IN_PROGRESS || callStatus === TwilioCallStatus.ANSWERED ? (
                            <h6 className='m-0 call-status-font'>{formatDuration(totalSeconds)}</h6>
                        ) : callStatus === TwilioCallStatus.COMPLETED ? (
                            <h6 className="m-0 call-status-font">Call ended</h6>
                        ) : callStatus === TwilioCallStatus.BUSY ? (
                            <h6 className="m-0 call-status-font">Busy</h6>
                        ) : callStatus === TwilioCallStatus.FAILED ? (
                            <h6 className="m-0 call-status-font">Unavailable User</h6>
                        ) : callStatus === TwilioCallStatus.NO_ANSWER ? (
                            <h6 className="m-0 call-status-font">No answer</h6>
                        ) : callStatus === TwilioCallStatus.CANCELED ? (
                            <h6 className="m-0 call-status-font">Canceled</h6>
                        ) : null}
                    </div>
                    {/* <div>
                        <p className="m-0">Phone</p>
                    </div> */}
                </div>
            </div>
            <div className="call-options">
                <ul>
                    {!callStarted && (
                        <>
                            <li style={{ background: "#2AC256", cursor: 'pointer' }}>
                                <img src={call_icon} alt="" onClick={handleCall} />
                            </li>
                            <li className="audio-cancel-button">
                                <img src={cancel_icon} alt="" onClick={handleCancel} />
                            </li>
                        </>
                    )}

                    {callStarted && (
                        <>
                            <li className="call-Started-child">
                                <div>
                                    <span>
                                        <img width={18} height={18} src={microphone_icon} alt="" />
                                    </span>
                                </div>
                                <p className="m-0">Microphone</p>
                            </li>
                            <li>
                                <div>
                                    <span>
                                        <img width={18} height={18} src={speaker_icon} alt="" />
                                    </span>
                                </div>
                                <p className="m-0">Speaker</p>
                            </li>
                            <li className='ml-auto ' style={{ cursor: 'pointer' }}>
                                <img src={call_icon} alt="" onClick={handleCancel} />
                            </li>
                        </>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default AudioCall;
